var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{staticClass:"ReCardTaskHelp light",attrs:{"type":"cinc"}},_vm._l((_vm.masTaskHelp),function(objTaskHelp){return _c('div',{key:'TASKHELPLINK'+objTaskHelp.id},[_c('a',{attrs:{"href":objTaskHelp.link,"target":"_blank","title":objTaskHelp.desct}},[_vm._v(_vm._s(objTaskHelp.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }